// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"7d848c1a","408":"c2f2802b","608":"6a213119","617":"b34d923e","843":"ddaa9c49"}[chunkId] + ".chunk.js";
};